module.exports = "/_next/static/images/bg-pk-time-1c8871c6.png";